
<div *rxLet="iconSet$; let iconSet" [innerHtml]="iconSet"></div>

